/**
 * RichTextEditor — lazy entry point.
 *
 * TipTap + ProseMirror are heavy (they pushed the main bundle past Vite's
 * 500 kB chunk warning), and most page views never open an editor. This
 * wrapper code-splits the real editor (RichTextEditorImpl) so it downloads
 * only when someone actually edits; consumers keep importing this path.
 */

import { Suspense, type ComponentProps } from 'react';
import { lazyRetry } from '../../lib/lazyRetry';

const Impl = lazyRetry(() => import('./RichTextEditorImpl'));

export default function RichTextEditor(props: ComponentProps<typeof Impl>) {
  return (
    <Suspense
      fallback={
        <div className={`border border-line rounded-lg bg-card px-3 py-2 text-sm text-ink-faint ${props.mode === 'inline' ? 'min-h-[40px]' : 'min-h-[120px]'}`}>
          Loading editor…
        </div>
      }
    >
      <Impl {...props} />
    </Suspense>
  );
}
